import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import logo from "../../resource/7.png";
import apiClient from "@/api/client";

const OrgainserRegister = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    date_of_birth: "",
    age: "",
    gender: "",
    address: "",
    city: "",
    postal_code: "",
    mobile_number: "",
    whatsapp_number: "",
    email_address: "",
    emergency_first_name: "",
    emergency_last_name: "",
    emergency_relationship: "",
    emergency_mobile_number_1: "",
    emergency_mobile_number_2: "",
    beginner: false,
    experienced_volunteer: false,
    months_experience: false,
    years_experience: false,
    months: "",
    description: ""
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === "checkbox") {
      // Handle exclusive checkboxes for beginner/experienced
      if (name === "beginner" && checked) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          beginner: true,
          experienced_volunteer: false
        }));
      } else if (name === "experienced_volunteer" && checked) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          beginner: false,
          experienced_volunteer: true
        }));
      } 
      // Handle exclusive checkboxes for months/years experience
      else if (name === "months_experience" && checked) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          months_experience: true,
          years_experience: false
        }));
      } else if (name === "years_experience" && checked) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          months_experience: false,
          years_experience: true
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: checked
        }));
      }
    } else if (type === "radio") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Required field validations
    if (!formData.first_name) newErrors.first_name = "First Name is required";
    if (!formData.last_name) newErrors.last_name = "Last Name is required";
    if (!formData.date_of_birth) newErrors.date_of_birth = "Date of birth is required";
    if (!formData.age) newErrors.age = "Age is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.postal_code) newErrors.postal_code = "Postal code is required";

    // Mobile number validation
    if (!formData.mobile_number) newErrors.mobile_number = "Mobile number is required";
    else if (!/^\+?\d{10,15}$/.test(formData.mobile_number.replace(/\s/g, ''))) {
      newErrors.mobile_number = "Invalid mobile number format";
    }

    // WhatsApp number validation
    if (!formData.whatsapp_number) newErrors.whatsapp_number = "WhatsApp number is required";
    else if (!/^\+?\d{10,15}$/.test(formData.whatsapp_number.replace(/\s/g, ''))) {
      newErrors.whatsapp_number = "Invalid WhatsApp number format";
    }

    // Email validation
    if (!formData.email_address) newErrors.email_address = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email_address)) {
      newErrors.email_address = "Invalid email format";
    }

    // Experience level validation
    if (!formData.beginner && !formData.experienced_volunteer) {
      newErrors.experience_level = "Please select your experience level";
    }

    // Experience duration validation
    if (!formData.months_experience && !formData.years_experience) {
      newErrors.experience_duration = "Please select experience duration";
    }

    // Emergency contact validations
    if (!formData.emergency_first_name) newErrors.emergency_first_name = "Emergency contact first name is required";
    if (!formData.emergency_last_name) newErrors.emergency_last_name = "Emergency contact last name is required";
    if (!formData.emergency_relationship) newErrors.emergency_relationship = "Relationship is required";
    if (!formData.emergency_mobile_number_1) newErrors.emergency_mobile_number_1 = "Emergency mobile number is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please check the form for errors.",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await apiClient.post('/create-internal-retreat-organiser-registrations',
        formData
      );


      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Organiser registration submitted successfully!",
      });

      // Reset form
      setFormData({
        first_name: "",
        last_name: "",
        date_of_birth: "",
        age: "",
        gender: "",
        address: "",
        city: "",
        postal_code: "",
        mobile_number: "",
        whatsapp_number: "",
        email_address: "",
        emergency_first_name: "",
        emergency_last_name: "",
        emergency_relationship: "",
        emergency_mobile_number_1: "",
        emergency_mobile_number_2: "",
        beginner: false,
        experienced_volunteer: false,
        months_experience: false,
        years_experience: false,
        months: "",
        description: ""
      });
      setErrors({});
    } catch (error) {
      console.error("Error submitting form:", error);

      let errorMessage = "Something went wrong!";
      if (error.response) {
        errorMessage = error.response.data.message || "An error occurred while submitting the form.";
      } else if (error.request) {
        errorMessage = "No response from the server. Please try again later.";
      }

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-page dark-gold">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">Internal Retreat Organiser Registration Form</h2>
          </div>
        </div>

        <p className="font-p mt-6">
          Welcome to Bhaddheka Vihari Monastery Internal Meditation Centre Registration for Organizers.
        </p>
        <p className="font-p mt-4">
          We are honoured to have you join us as a retreat organizer. Your role is integral to supporting individuals who seek inner peace and balance, providing them with a serene space to immerse in practices focused on personal and spiritual growth. At Bhaddheka Vihari Monastery, we are committed to fostering spiritual development, and we deeply appreciate your involvement in ensuring the seamless execution of our internal retreats.
        </p>
        <p className="font-p mt-4">
          As a volunteer, you are offered a unique opportunity to contribute to the creation of a tranquil, meditative environment for our guests. This selfless service is regarded as a noble and meritorious deed, benefiting not only those on their spiritual journey but also contributing significantly to your own personal growth. We trust that your efforts will enhance the retreat experience for all involved, and your role is pivotal in nurturing the atmosphere of peace and reflection that our retreats are known for.
        </p>
        <p className="font-p mt-4">
          We look forward to working with you. Please fill in the following details to register.
        </p>

        <p className="font-p mt-5">Full Name *</p>

        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="text"
              id="first_name"
              name="first_name"
              value={formData.first_name}
              onChange={handleInputChange}
            />
            <label htmlFor="first_name">First Name</label>
            {errors.first_name && <span className="error">{errors.first_name}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="last_name"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
            />
            <label htmlFor="last_name">Last Name</label>
            {errors.last_name && <span className="error">{errors.last_name}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="date"
              id="date_of_birth"
              name="date_of_birth"
              value={formData.date_of_birth}
              onChange={handleInputChange}
            />
            <label htmlFor="date_of_birth">Date of birth*</label>
            {errors.date_of_birth && <span className="error">{errors.date_of_birth}</span>}
          </div>
          <div className="form-item">
            <input
              type="number"
              id="age"
              name="age"
              value={formData.age}
              onChange={handleInputChange}
            />
            <label htmlFor="age">Age*</label>
            {errors.age && <span className="error">{errors.age}</span>}
          </div>
        </div>

        <p className="font-p mt-5">Gender*</p>
        <div className="gender-box">
          <div>
            <input
              type="radio"
              id="male"
              name="gender"
              value="Male"
              checked={formData.gender === "Male"}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="male">Male</label>
          </div>
          <div>
            <input
              type="radio"
              id="female"
              name="gender"
              value="Female"
              checked={formData.gender === "Female"}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="female">Female</label>
          </div>
        </div>
        {errors.gender && <span className="error">{errors.gender}</span>}

        <p className="font-p mt-5">Address*</p>

        <div className="form-box1">
          <div className="form-item">
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
            <label htmlFor="address">Street Address</label>
            {errors.address && <span className="error">{errors.address}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
            />
            <label htmlFor="city">City</label>
            {errors.city && <span className="error">{errors.city}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="postal_code"
              name="postal_code"
              value={formData.postal_code}
              onChange={handleInputChange}
            />
            <label htmlFor="postal_code">Postal/Zip Code*</label>
            {errors.postal_code && <span className="error">{errors.postal_code}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="tel"
              id="mobile_number"
              name="mobile_number"
              value={formData.mobile_number}
              onChange={handleInputChange}
            />
            <label htmlFor="mobile_number">Mobile Number</label>
            {errors.mobile_number && <span className="error">{errors.mobile_number}</span>}
          </div>
          <div className="form-item">
            <input
              type="tel"
              id="whatsapp_number"
              name="whatsapp_number"
              value={formData.whatsapp_number}
              onChange={handleInputChange}
            />
            <label htmlFor="whatsapp_number">WhatsApp Number</label>
            {errors.whatsapp_number && <span className="error">{errors.whatsapp_number}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="email"
              id="email_address"
              name="email_address"
              value={formData.email_address}
              onChange={handleInputChange}
            />
            <label htmlFor="email_address">Email Address</label>
            {errors.email_address && <span className="error">{errors.email_address}</span>}
          </div>
        </div>

        <h1 className="font-second mt-6">Emergency Contact</h1>
        <p className="font-p mt-5">Full Name*</p>

        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="text"
              id="emergency_first_name"
              name="emergency_first_name"
              value={formData.emergency_first_name}
              onChange={handleInputChange}
            />
            <label htmlFor="emergency_first_name">First Name</label>
            {errors.emergency_first_name && <span className="error">{errors.emergency_first_name}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="emergency_last_name"
              name="emergency_last_name"
              value={formData.emergency_last_name}
              onChange={handleInputChange}
            />
            <label htmlFor="emergency_last_name">Last Name</label>
            {errors.emergency_last_name && <span className="error">{errors.emergency_last_name}</span>}
          </div>
        </div>

        <p className="font-p mt-5">Relationship*</p>

        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="text"
              id="emergency_relationship"
              name="emergency_relationship"
              value={formData.emergency_relationship}
              onChange={handleInputChange}
            />
            <label htmlFor="emergency_relationship">Relationship</label>
            {errors.emergency_relationship && <span className="error">{errors.emergency_relationship}</span>}
          </div>
        </div>

        <p className="font-p mt-5">Contact Number*</p>
        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="tel"
              id="emergency_mobile_number_1"
              name="emergency_mobile_number_1"
              value={formData.emergency_mobile_number_1}
              onChange={handleInputChange}
            />
            <label htmlFor="emergency_mobile_number_1">Mobile Number 1*</label>
            {errors.emergency_mobile_number_1 && <span className="error">{errors.emergency_mobile_number_1}</span>}
          </div>
          <div className="form-item">
            <input
              type="tel"
              id="emergency_mobile_number_2"
              name="emergency_mobile_number_2"
              value={formData.emergency_mobile_number_2}
              onChange={handleInputChange}
            />
            <label htmlFor="emergency_mobile_number_2">Mobile Number 2</label>
          </div>
        </div>

        <p className="font-p mt-5">
          Please indicate if you are a beginner or an experienced organiser.
        </p>

        <div className="selection mt-4">
          <div className="checkbox-box">
            <label htmlFor="beginner">Beginner</label>
            <input
              type="checkbox"
              id="beginner"
              name="beginner"
              className="checkbox"
              checked={formData.beginner}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="experienced_volunteer">Experienced volunteer</label>
            <input
              type="checkbox"
              id="experienced_volunteer"
              name="experienced_volunteer"
              className="checkbox"
              checked={formData.experienced_volunteer}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {errors.experience_level && <span className="error">{errors.experience_level}</span>}

        <p className="font-p mt-5">
          Please indicate your level of experience working as volunteer
        </p>

        <div className="selection mt-4">
          <div className="checkbox-box">
            <label htmlFor="months_experience">Months</label>
            <input
              type="checkbox"
              id="months_experience"
              name="months_experience"
              className="checkbox"
              checked={formData.months_experience}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="years_experience">Years</label>
            <input
              type="checkbox"
              id="years_experience"
              name="years_experience"
              className="checkbox"
              checked={formData.years_experience}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {errors.experience_duration && <span className="error">{errors.experience_duration}</span>}

        <p className="font-p mt-5">
          Please indicate which month/s you would like to volunteer doing internal retreats.
        </p>

        <div className="form-item mt-5">
          <label htmlFor="months" className="font-p">
            Months
          </label>
          <input
            type="number"
            id="months"
            name="months"
            value={formData.months}
            onChange={handleInputChange}
          />
        </div>

        <p className="font-p mt-5">
          Please ask any questions or queries you would like to clarify regarding volunteering for internal retreats at the monastery.
        </p>

        <div className="mt-5">
          <div className="form-item">
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows="6"
            />
            <label htmlFor="description"></label>
          </div>
        </div>

        <button type="submit" id="submitbtn" className="mt-5" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>

        <p className="font-p mt-5 pb-4">
          We are grateful for your dedication. Together, we can create a welcoming and enriching space at Bhaddheka Vihari Monastery Internal Meditation Centre.
        </p>
      </form>
    </div>
  );
};

export default OrgainserRegister;